import { JSX } from 'react';
import { InView } from 'react-intersection-observer';

export default function Diff({
  descendants,
  analytics,
  onSectionView,
}: {
  descendants: {
    title: string | JSX.Element;
    text: string | JSX.Element;
    image: string;
  }[];
  analytics: {
    label: string;
    value: string;
  };
  onSectionView: (
    label: string,
    value: string,
    extraData?: Record<string, string>,
  ) => void;
}): JSX.Element {
  return (
    <section id="difference" className="pi-careplus__diff">
      <div className="pi-careplus__diff--content">
        <InView
          as="h2"
          triggerOnce={true}
          onChange={(inView: any) => {
            if (!inView) return;
            onSectionView(analytics.label, analytics.value);
          }}
          className="pi-careplus__diff--title"
        >
          The CarePlus
          <small className="pi-careplus__diff--title-registered">®</small>{' '}
          Difference
          <small className="pi-careplus__diff--title-annotation">2</small>
        </InView>
        <ul className="pi-careplus__diff--cards">
          {descendants.map(
            (
              {
                title,
                text,
                image,
              }: {
                title: string | JSX.Element;
                text: string | JSX.Element;
                image: string;
              },
              i: number,
            ): JSX.Element => {
              const name = `pi-careplus__diff--card-${i}`;
              return (
                <li key={name} className={`pi-careplus__diff--card ${name}`}>
                  <div className="pi-careplus__diff--icon">
                    <img data-src={image} alt="" className="lazyload pi-icon" />
                  </div>
                  <h3 className="pi-careplus__diff--subtitle">{title}</h3>
                  <p className="pi-careplus__diff--subtext">{text}</p>
                </li>
              );
            },
          )}
        </ul>
      </div>
    </section>
  );
}
